module.exports = __webpack_public_path__ + "img/MO-P.d997a9ab.png";